import { render, staticRenderFns } from "./GuidedRegulationExemptionsField.vue?vue&type=template&id=590173fa&scoped=true&"
import script from "./GuidedRegulationExemptionsField.vue?vue&type=script&lang=js&"
export * from "./GuidedRegulationExemptionsField.vue?vue&type=script&lang=js&"
import style0 from "./GuidedRegulationExemptionsField.vue?vue&type=style&index=0&id=590173fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "590173fa",
  null
  
)

export default component.exports